module.exports = __webpack_public_path__ + "img/beixing.9127dbd1.jpg";